// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc701bfb","239":"8842cf4e","453":"46dc3e92","455":"a1540df9","726":"56c05ec2"}[chunkId] + ".chunk.js";
};